import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import AttendanceDetailDatatable from './AttendanceDetailDatatable';
import AttendanceDetailModal  from './AttendanceDetailModal';
import AttendanceDetailAddDayModal  from './AttendanceDetailAddDayModal';
import * as RestService from '../../services/eisRest';


const AttendanceDetailTab = (props) => {

    const [state , setState]= useState({show: false,
                                        showAddDay : false,
                                        showType: 'Day',
                                        selectedDetailRecord: '',
                                        checkTime: Date.now(),
                                        selectedRecord: '',
                                        editEnabled: false});
    //const [show , setShow]= useState( false );
    //const [showAddDay , setShowAddDay]= useState( false );
    //const [selectedRecord, setSelectedRecord ] = useState();    
    //const [selectedDetailRecord, setSelectedDetailRecord ] = useState();    
    //const [checkTime, setCheckTime] = useState(null);
    //const [editEnabled,setEditEnabled] = useState( false );
   
    const handleCallback = (id) => {
          setState({...state, selectedDetailRecord: id, show: true})
          //setSelectedDetailRecord(id);                 
          //setShow(true);   
    };
 
    const modalCallback = (isShow) => {    
      
      setState({...state, checkTime: Date.now(), show: isShow})
      //setShow(isShow);   
      //setCheckTime(Date.now());
      //setDataChanged(dataChanged) ;         
    }

 
  

    useEffect(() => {      
      //setSelectedRecord(props.selectedRecord);      


      RestService.callAnyApi('attendance/getAttendance?id='+props.selectedRecord, null)
      .then((data) => {   
          if(data.lock===1){
            //setState({...state, editEnabled: false});
            //setEditEnabled(false);    
            setState({...state, selectedRecord: props.selectedRecord, checkTime: Date.now(),editEnabled: false})
          }
          if(data.lock===0){
          //  setState({...state, editEnabled: false});
            //setEditEnabled(true);    
            setState({...state, selectedRecord: props.selectedRecord, checkTime: Date.now(),editEnabled: true})
          }
      })
      .catch((error) => {
        //setEditEnabled(false);
        setState({...state, editEnabled: false});
      });


      
    }, [props.selectedRecord]) //,checkTime
  

    const modalAddDayCallback = (showAddDay) => {             
      //setShowAddDay(isShow);    
      //setCheckTime(Date.now());    
      setState({...state, checkTime: Date.now(), showAddDay: showAddDay})      
    }

    const addDay = () => {
      //setShowAddDay(true); 
      setState({...state, showAddDay: true});
    }


    const onChangeValue = (event) => {
      console.log(event.target.value);
      setState({...state, showType: event.target.value})
    }

    useEffect(() => {
      //callFetchData();
      if(props.isActive){
        //setCheckTime(Date.now()); 
        //setSelectedRecord(props.selectedRecord);    
       // setState({...state, checkTime: Date.now()})   //, selectedRecord: props.selectedRecord
      }
    }, [props.isActive]);
  
    

    return (
      <>
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <AttendanceDetailDatatable            
            parentCallback={handleCallback}    
            //selectedRecord={state.selectedRecord}   
            //checkTime={state.checkTime}
            //editEnabled={state.editEnabled}            
            state={state}            
          />
          

          <div style={{display: 'flex', flexDirection: 'row'}}>

              <div class="form-group clearfix">
                  <Button
                        bsStyle="primary"
                    //  bsSize="large"
                        className="ml-3 mt-3"
                        onClick={() => addDay()} 
                    >
                        <i class="fas fa-plus"></i>
                  </Button>
              </div>

              <div class="form-group clearfix" style={{marginTop: '25px', marginLeft: '20px'}}>
                  <div class="icheck-primary d-inline">
                      <input type="radio" id="radioPrimary1" name="r1" value="Day" checked={state.showType === "Day"} onChange={onChangeValue} />
                      <label for="radioPrimary1">Detail</label>
                  </div>
                  <div class="icheck-primary d-inline" style={{marginLeft: '20px'}}>
                      <input type="radio" id="radioPrimary2" name="r1" value="Week" checked={state.showType === "Week"} onChange={onChangeValue} />
                      <label for="radioPrimary2">Týždeň</label>
                  </div>
              </div>

         </div>     

        </div>

        <AttendanceDetailModal 
          modal={state.show}
          parentCallback={modalCallback}
          selectedRecord={state.selectedDetailRecord}            
        />  

        <AttendanceDetailAddDayModal 
            modal={state.showAddDay}
            parentCallback={modalAddDayCallback}
            selectedRecord={state.selectedRecord}                      
        />


           

       </> 
    );
};

export default AttendanceDetailTab;